import { Box, Stack, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import Search from "./Search";

const SearchPanel = () => {
  const [endingIndex, setEndingIndex] = useState(0);

  const endings = [
    "to the right spot.",
    "with perfect waves.",
    "with fast Wi‑Fi.",
    "with local tips.",
    "with zero guesswork.",
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setEndingIndex((prev) => (prev + 1) % endings.length);
    }, 3000);

    return () => clearInterval(interval);
  }, []);

  return (
    <Stack
      direction="column"
      justifyContent="center"
      alignItems={"center"}
      sx={{
        width: "100%",
        minHeight: { xs: 260, sm: 360 },
        py: { xs: 4, sm: 6, md: 8 },
        px: { xs: 2, sm: 4 },
        backgroundSize: "cover", // Adjust the size of the background image
        backgroundPosition: "bottom", // Center the background image
        backgroundRepeat: "no-repeat",
        backgroundImage: `url(https://images.unsplash.com/photo-1526342122811-2a9c8512023d?q=80&w=3540&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D)`,
        boxSizing: "border-box",
      }}
    >
      <Box
        sx={{
          width: "100%",
          maxWidth: 900,
          display: "flex",
          flexDirection: "column",
          alignItems: { xs: "flex-start", sm: "center" },
          gap: { xs: 2, sm: 3 },
        }}
      >
        <Typography
          variant="h4"
          color="white"
          sx={{
            textShadow: "2px 2px 2px rgba(0, 0, 0, 0.15)",
            display: { xs: "flex", sm: "none" },
            fontWeight: 600,
          }}
        >
          Work Surf Repeat
        </Typography>
        <Typography
          variant="h2"
          color="white"
          sx={{
            textShadow: "2px 2px 2px rgba(0, 0, 0, 0.15)",
            display: { xs: "none", sm: "flex" },
            fontWeight: 600,
            textAlign: "center",
          }}
        >
          Work Surf Repeat
        </Typography>

        <Typography
          variant="h6"
          color="white"
          sx={{
            textShadow: "2px 2px 2px rgba(0, 0, 0, 0.2)",
            maxWidth: 720,
            textAlign: { xs: "left", sm: "center" },
          }}
        >
          Plan your next surf‑friendly work trip{" "}
          <Box
            component="span"
            sx={{
              fontWeight: 700,
              display: "inline-block",
              ml: 0.5,
              minWidth: "140px",
              transition: "opacity 0.3s ease",
            }}
          >
            {endings[endingIndex]}
          </Box>
        </Typography>
      </Box>
      <Stack
        id="searchBar"
        sx={{
          width: "100%",
          maxWidth: 720,
          mt: { xs: 3, sm: 4 },
          px: { xs: 1, sm: 0 },
        }}
        direction="row"
        justifyContent="center"
        alignItems={"center"}
      >
        <Search />
      </Stack>

      <Typography
        variant="body2"
        color="white"
        sx={{
          mt: { xs: 2, sm: 3 },
          px: { xs: 3, sm: 0 },
          maxWidth: 720,
          textAlign: { xs: "left", sm: "center" },
          textShadow: "1px 1px 2px rgba(0, 0, 0, 0.35)",
        }}
      >
        100% community‑powered: discover and share surf‑work spots.
      </Typography>
    </Stack>
  );
};

export default SearchPanel;
